import { Pipe, PipeTransform } from '@angular/core';
import { interval, Observable, of } from 'rxjs';
import { UtilityService } from '../services';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'sdTimeDifferent',
})
export class SdTimeDifferentPipe implements PipeTransform {
  private maxSecond = 60;
  private maxMinute = this.maxSecond * 60;
  private maxHour = this.maxMinute * 24;
  private maxDay = this.maxHour * 30;
  private maxMonth = this.maxHour * 365;
  constructor(private utilityService: UtilityService) { }
  transform(value: any, format: string, different: 'second' | 'minute' | 'hour' | 'day' | 'month'): Observable<string> {
    if (!Date.isDate(value)) {
      return of(null);
    }
    if (!different) {
      return of(Date.toFormat(value, format));
    }
    if (Math.round((new Date().getTime() - new Date(value).getTime()) / 1000) < 0) {
      return of(Date.toFormat(value, format));
    }
    return interval(1000).pipe(map(() => {
      const timeDifferent = Math.round((new Date().getTime() - new Date(value).getTime()) / 1000);
      if (different === 'month' && timeDifferent < this.maxMonth) {
        return this.utilityService.timeDifference(value);
      }
      if (different === 'day' && timeDifferent < this.maxDay) {
        return this.utilityService.timeDifference(value);
      }
      if (different === 'hour' && timeDifferent < this.maxHour) {
        return this.utilityService.timeDifference(value);
      }
      if (different === 'minute' && timeDifferent < this.maxMinute) {
        return this.utilityService.timeDifference(value);
      }
      if (different === 'second' && timeDifferent < this.maxSecond) {
        return this.utilityService.timeDifference(value);
      }
      return Date.toFormat(value, format);
    }));
  }
}
